<template>
    <div class="p-10 overflow-scroll">
        <hts-data-table
            :headers="driverHistoryDetail"
            :items="rowData" />
    </div>
</template>
<script lang="ts" setup>
const { $formatters } = useNuxtApp()

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  params: Object
})
const { params } = toRefs(props)
const driverHistoryDetailData: { [key: string]: any } = ref({})
const rowData: Array<Object> = []
onMounted(() => {
  driverHistoryDetailData.value = params?.value?.data
})
watch(
  () => driverHistoryDetailData.value,
  () => {
    const oldData = driverHistoryDetailData.value.oldData
    const newData = driverHistoryDetailData.value.newData.$set

    const labelData = { ...oldData }
    Object.assign(labelData, { ...newData })

    Object.keys(oldData).forEach((key: any) => {
      if (key === 'updatedAt' || key === 'updatedBy') {
        return null
      }
      rowData.push({
        dataName: checkNameData(key),
        oldData: oldData[key] || '',
        newData: newData[key] || ''
      })
    })
  }
)
const driverHistoryDetail = [
  {
    field: 'dataName',
    label: 'dataName',
    headerName: $t('labels.driverHistory.nameData'),
    sortable: true
  },
  {
    field: 'oldData',
    label: 'oldData',
    headerName: $t('labels.driverHistory.oldData'),
    sortable: true,
    valueGetter: (params: any) => {
      const oldDataValue = params.data.oldData
      if (Date.parse(oldDataValue) && oldDataValue.includes('T')) {
        return $formatters.date(oldDataValue)
      }
      if (typeof oldDataValue !== 'object') {
        return oldDataValue
      }
      return oldDataValue.$numberDecimal
    }
  },
  {
    field: 'newData',
    label: 'newData',
    headerName: $t('labels.driverHistory.newData'),
    sortable: true,
    valueGetter: (params: any) => {
      const newDataValue = params.data.newData
      if (Date.parse(newDataValue) && newDataValue.includes('T')) {
        return $formatters.date(newDataValue)
      }
      if (typeof newDataValue !== 'object') {
        return newDataValue
      }
      return newDataValue.$numberDecimal
    }
  }
]

const checkNameData = (keyData: string) => {
  if (!keyData) {
    return false
  }
  switch (keyData) {
  case 'name':
    return 'Tên tài xế'
  case 'licenseType':
    return 'Loại bằng lái'
  case 'licenseNumber':
    return 'Số bằng lái'
  case 'licenseDate':
    return 'Hạn bằng lái'
  case 'idCardNumber':
    return 'Số CMND/CCCD'
  case 'birthDay':
    return 'Ngày sinh'
  case 'lastHeathCheck':
    return 'Ngày khám sức khỏe cuối cùng'
  case 'lastHeathCheckValue':
    return 'Kết quả khám sức khỏe'
  case 'status':
    return 'Trạng thái'
  default:
    return 'Field name'
  }
}
</script>
